import { render, staticRenderFns } from "./AgingComponent.vue?vue&type=template&id=702aa241"
import script from "./AgingComponent.vue?vue&type=script&lang=js"
export * from "./AgingComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports